import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export type FromCalendarType = 'pulverization' | 'creation'

interface CalendarDiagnosis {
  id: string
  name: string
  culture: Culture
  treatment: Treatment
  date?: string
}

export interface GetCalendarDiagnosesParams {
  from: FromCalendarType
  search?: string
}

export interface GetCalendarDiagnosesConfig {
  signal?: AbortSignal
}

export type GetCalendarDiagnosesResponse = {
  diagnoses: CalendarDiagnosis[]
}

export async function getCalendarDiagnoses(
  { search, from }: GetCalendarDiagnosesParams,
  { signal }: GetCalendarDiagnosesConfig = {},
) {
  const { data } = await companiesApi.get<GetCalendarDiagnosesResponse>(
    apiRoutes.getCalendarDiagnoses,
    {
      params: {
        from,
        search,
      },
      signal,
    },
  )

  return data
}
